import { useEffect, useState } from "react";
import "./intro.css";
// import spaceBg from "../../images/eu-no-espaco.png";
import spaceBg from "../../images/ficou-foda.webp";
import { useProfile } from "../../hooks/useProfile";

function Intro() {
  const [visible, setVisible] = useState(false);
  const profile = useProfile();
  const intro = profile.intro || {};
  const buttonsLabel = intro.buttonsLabel || "Professional profiles";

  const openExternal = (url) => {
    if (typeof window === "undefined") return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    // dispara após montar
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="home"
      className={`s-intro target-section ${visible ? "is-visible" : ""}`}
    >
      <div
        className="intro__grid"
        data-reveal-left
        data-aos="fade-right"
        data-aos-delay="350"
      >
        {/* Coluna da imagem (esquerda) — entra depois */}
        <div className="intro__media">
          <img
            src={spaceBg}
            alt={intro.imageAlt || "Airton in space"}
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* Coluna do texto (direita) — entra primeiro */}
        <div
          className="intro__content"
          data-aos="fade-right"
          data-aos-delay="60"
        >
          <div className="intro__panel">
            <header className="intro__panel-header">
              <span className="intro__panel-eyebrow">{intro.greeting}</span>
              <h1 id="intro-title" className="intro__panel-title">
                {profile.name}
              </h1>
              <h2 className="intro__panel-subtitle">{intro.role}</h2>
            </header>

            <p className="intro__panel-summary">
              {intro.blurb} <br />
            </p>

            <ul className="intro__panel-highlights">
              {(intro.itemsIntro || []).map((item) => (
                <li key={item} className="intro__panel-highlight">
                  {item}
                </li>
              ))}
            </ul>

            <div
              className="intro__panel-buttons"
              role="group"
              aria-label={buttonsLabel}
            >
              <button
                type="button"
                onClick={() =>
                  openExternal("https://github.com/AirtonDomiciano")
                }
                className="intro__panel-button intro__panel-button--primary"
              >
                {profile.btnGithub || "Ver GitHub"}
              </button>
              <a
                href="https://www.canva.com/design/DAG8wNQjpIQ/7nC-F9GuMTAfPCPVEZP9CA/view?utm_content=DAG8wNQjpIQ&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h05479ff822"
                download
                className="intro__panel-button intro__panel-button--secondary"
              >
                {profile.btnDownloadCV || "Baixar CV"}
              </a>
              <button
                type="button"
                onClick={() =>
                  openExternal(
                    "https://www.linkedin.com/in/airton-domiciano-93b081213/"
                  )
                }
                className="intro__panel-button intro__panel-button--ghost"
              >
                {profile.btnLinkedIn || "Conectar no LinkedIn"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
